export const ellipsis = () => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});

export const sticky = (bgColor, topDistance = 0, zIndex = 999) => ({
  position: 'sticky',
  zIndex,
  background: bgColor,
  top: topDistance,
});

export const richTextContentStyles = ({ palette: { primary }, spacing }) => ({
  color: `${primary.bluish1}`,
  wordBreak: 'break-word',
  '& p': {
    color: 'inherit',
    margin: 0,
    padding: 0,
  },
  '& span': {
    color: 'inherit',
  },
  '& strong': {
    fontFamily: 'ProximaNova-Bold',
    color: 'inherit',
    fontWeight: 'normal',
    fontStyle: 'normal',
    '& em': {
      fontFamily: 'ProximaNova-Bold',
      color: 'inherit',
      fontStyle: 'italic',
    },
  },
  '& em': {
    fontFamily: 'ProximaNova-RegularIt',
    color: 'inherit',
    fontWeight: 'normal',
    fontStyle: 'normal',
  },
  '& ul': {
    margin: 0,
    padding: 0,
    paddingLeft: spacing(4),
    color: 'inherit',
    '& li': {
      marginBottom: spacing(1.5),
      color: 'inherit',
    },
  },
  '& a': {
    color: `${primary.main}`,
  },
});
